import type { Trip } from './model';

export function managementTrips(trips: Trip[]): Trip[] {
  return trips.flatMap((trip) => {
    const status = trip.assessment?.phase.trim().toLocaleLowerCase('pt-BR');
    if (status === 'finalizado' || status === 'finalizada') return [];
    const awaitingUnload = status === 'aguardando descarga';
    const awaitingLoad = status === 'aguardando carregamento';
    return [{
      ...trip,
      events: {
        ...trip.events,
        unloaded: awaitingUnload ? undefined : trip.events.unloaded,
        loaded: awaitingUnload || awaitingLoad ? undefined : trip.events.loaded,
      },
    }];
  });
}
